import stylex from '@stylexjs/stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { palette } from '@shared/tokens/palette.stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    padding: '8px 16px',
    alignItems: 'flex-start',
    gap: anatomy['size-8'],
    borderRadius: '8px',
    width: '100%',
  },
  ERROR: {
    background: colors.errorBackground,
  },
  WARNING: {
    background: colors.warningBackground,
  },
  INFO: {
    background: colors.infoBackground,
  },
  EXCLAMATION: {
    background: palette['orange-50'],
  },
  content: {
    color: palette['greyBlack'],
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-1'],
    flex: 1,
    minWidth: 0,
  },
});
